import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { icon } from './../../../icons/icons';
import { DragHandle } from './../ContentBodyContainer';


// actions
import * as actions from './../../../actions/actions';

class WidgetWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.onWidgetClick = this.onWidgetClick.bind(this);
        this.deleteWidget = this.deleteWidget.bind(this);
    }

    componentWillMount() {
        // console.log('component will mount !');
    }

    componentWillUnmount() {
        // console.log('component un mount !');
    }

    onWidgetClick(e) {
        const widgetId = this.props.children.props.widget.id;
        const widgetKind = this.props.children.props.widget.kind;

        if (this.props.mode === 'EDIT') {
            if (this.props.activeWidget === widgetId) {
                return false;
            }

            this.props.actions.setActiveWidget(widgetId);
            this.props.actions.setWidgetTools(widgetKind, widgetId);
        } else {
            return false;
        }
        e.stopPropagation();
        e.preventDefault();
    }

    deleteWidget(e) {
        const widgetId = this.props.children.props.widget.id;

        if (this.props.mode === 'EDIT') {
            this.props.actions.setModal('DELETE_WIDGET', 'Warning', 'Are you sure you want to delete this widget ?', widgetId);
        }

        e.stopPropagation();
        e.preventDefault();
    }

    render() {
        const { mode, activeWidget } = this.props;
        const widget = this.props.children.props.widget;
        const widgetCss = classNames({
            'component': true,
            'component--active': (activeWidget === widget.id),
        });

        return (
            <div key={widget.id} className={widgetCss} onClick={this.onWidgetClick}>
                {
                    (mode === 'EDIT') ?
                        <div className="component__icons">
                            <div className="component--delete icon icon-label" onClick={this.deleteWidget}>{ icon.thrash() } <span>Delete</span></div>
                            <DragHandle />
                        </div>
                    : null
                }
                { this.props.children }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    mode: state.app.mode,
    activeWidget: state.widgets.activeWidget,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

WidgetWrapper.propTypes = {
    mode: PropTypes.string.isRequired,
    activeWidget: PropTypes.number,
    actions: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(WidgetWrapper);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/WidgetWrapper.jsx